<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'NAVIGATION.TABS.STAGING' | translate }}
    </glxy-page-title>
    @if ((isExpress$ | async) === false) {
      <glxy-page-actions>
        <a class="toolbar-help-button" mat-icon-button target="_blank" href="https://websitepro.zendesk.com/hc/en-us">
          <mat-icon>help_outline</mat-icon>
        </a>
      </glxy-page-actions>
    }
  </glxy-page-toolbar>

  @if ((isExpress$ | async) === false) {
    <glxy-page-wrapper>
      <div class="page page-wide">
        <div class="center">
          @if (stagingStatus$ | async; as stagingStatus) {
            @switch (stagingStatus) {
              @case ('off') {
                <app-staging-desc-card (createRequest)="sendCreateRequest()"></app-staging-desc-card>
              }
              @case ('creating') {
                <div>{{ 'PAGES.STAGING.CREATING.TITLE' | translate }}</div>
                <mat-spinner class="info-spinner" mode="indeterminate" color="accent"></mat-spinner>
                <div class="staging-creating-subtitle">
                  {{ 'PAGES.STAGING.CREATING.DESCRIPTION' | translate }}
                </div>
              }
              @case ('publishing') {
                <div>{{ 'PAGES.STAGING.PUBLISHING.TITLE' | translate }}</div>
                <mat-spinner class="info-spinner" mode="indeterminate" color="accent"></mat-spinner>
                <div class="staging-creating-subtitle">
                  {{ 'PAGES.STAGING.PUBLISHING.DESCRIPTION' | translate }}
                </div>
              }
              @case ('finished') {
                <app-push-finished-card
                  [siteId]="siteId$ | async"
                  [status]="(lastJobInfo$ | async).status"
                ></app-push-finished-card>
              }
              @case ('on') {
                <div class="app-staging">
                  <div class="manage-site">
                    <app-manage-staging-site
                      [siteId]="siteId$ | async"
                      [domain]="(site$ | async)?.stagingDomain"
                      [editURL]="editUrl$ | async"
                    ></app-manage-staging-site>
                    <app-debug-site-card [instance]="instance"></app-debug-site-card>
                  </div>
                  <div>
                    <app-push-to-live-card
                      (pushLiveRequest)="sendPushLiveRequest($event.valueOf())"
                    ></app-push-to-live-card>
                    <app-reset-staging-card
                      (resetRequest)="sendResetRequest()"
                      (resetFromTemplateRequest)="sendResetFromTemplateRequest($event)"
                    ></app-reset-staging-card>
                  </div>
                </div>
              }
            }
          } @else {
            <mat-spinner class="info-spinner" mode="indeterminate" color="accent"></mat-spinner>
          }
        </div>
      </div>
    </glxy-page-wrapper>
  }
</glxy-page>
